export default {
  AIwriter_embed_html: 'HTML 可视化',
  AIwriter_embed_backtest_results: '回测结果',
  AIwriter_embed_cards: '资讯卡片',
  AIwriter_embed_cards_hint: '资讯卡片占位。完整展示需要文章的扩展卡片数据。',

  AIwriter_embed_visualization: '数据可视化',
  AIwriter_embed_stock: '股票评分卡',
  AIwriter_embed_technology: '技术分析卡',
  AIwriter_embed_funds: '资金流向卡',
  AIwriter_embed_analyst: '分析师评级卡',
  AIwriter_embed_fundamentals: '基本面卡',
  AIwriter_embed_prediction: '预测市场卡',
  AIwriter_embed_aime: 'Ask Aime 问句',
  AIwriter_embed_iframe: '嵌入内容',
  AIwriter_embed_hint: '此组件及参数会随正文保存，打开预览查看完整内容。',

  AIwriter_backtest_title: '快捷回测工具',
  AIwriter_backtest_hint: '回测组件。打开预览可查看完整交互工具。',
  AIwriter_Tone: '语气',
  AIwriter_formal: '正式',
  AIwriter_informal: '非正式',
  AIwriter_words: '词数',
  AIwriter_new: '新建',
  AIwriter_Untitled: '未命名',
  AIwriter_welcomemessage: '在此开启你的写作之路...',
  AIwriter_typeprompt: '在此输入任何内容',
  AIwriter_airewriting: 'AI改写',
  AIwriter_publish: '发布',
  AIwriter_save: '保存',
  AIwriter_logowords: '回响创作',
  AIwriter_delete: '删除',
  AIwriter_delete_draft: '删除草稿？',
  AIwriter_deleteconfirm: '你确定要删除这篇文章吗？',
  AIwriter_cancel: '取消',
  AIwriter_confirm: '确认',
  AIwriter_autosaved: '已自动保存',
  AIwriter_aisearch: 'AI搜索',
  AIwriter_askprompt: '在下方问你想问的任何问题...',
  AIwriter_askanything: '问你想问...',
  AIwriter_answer: '回答',
  AIwriter_decoration: '全文润色',
  AIwriter_image: '图片',
  AIwriter_link: '链接',
  AIwriter_stockcode: '股票代码',
  AIwriter_settings: '设置',
  AIwriter_unlimited: '不限制',
  AIwriter_results: '结果',
  AIwriter_replace: '替换',
  AIwriter_publishinfo: '发布信息',
  AIwriter_coverpage: '封面',
  AIwriter_coverprompt: '点击或拖动来上传封面图',
  AIwriter_publishchannels: '发布渠道',
  AIwriter_apps: '应用',
  AIwriter_terminal: '发布端',
  AIwriter_category: '类别',
  AIwriter_submit: '提交',
  AIwriter_close: '关闭',
  AIwriter_preview: '预览',
  AIwriter_publishcompleted: '发布成功',
  AIwriter_saving: '保存中...',
  AIwriter_savedsuccessfully: '保存成功',
  AIwriter_modifyingtone: 'AI正在修改语气',
  AIwriter_stop: '停止',
  AIwriter_name: '名称',
  AIwriter_linkprompt: '不包含http://等协议名称',
  AIwriter_codeprompt: '输入完整的股票代码',
  AIwriter_codeerrorprompt: '股票代码不正确',
  AIwriter_generateoutline: 'AI正在生成大纲',
  AIwriter_generatelogic: 'AI正在生成写作思路',
  AIwriter_retrievedata: 'AI正在取数',
  AIwriter_analysedata: 'AI正在分析数据',
  AIwriter_writingparagraph: 'AI正在生成段落',
  AIwriter_writingconcepts: '写作思路',
  AIwriter_writingcompletion: 'AI写作已完成。优化之后，点击生成按钮生成文章。',
  AIwriter_addnewtitle: '新增标题',
  AIwriter_citations: '引用',
  AIwriter_aicreation: 'AI创作',
  AIwriter_login: '登录',
  AIwriter_logout: '退出登录',
  AIwriter_signup: '注册',
  AIwriter_deletefailed: '删除失败',
  AIwriter_generate: '生成',
  AIwriter_regenerate: '重新生成',
  AIwriter_searcherrorprompt: '很抱歉，AI搜索失败。请重试。',
  AIwriter_searchenterprompt: '请先在左侧输入内容',
  AIwriter_coverimageprompt: '请添加封面图。',
  AIwriter_savefailed: '保存失败',
  AIwriter_selectapplication: '请选择一个应用',
  AIwriter_selectterminal: '请选择一个Terminal',
  AIwriter_selectcolumn: '请选择一个栏目',
  AIwriter_picuploadprompt: '只能上传JPG/PNG文件',
  AIwriter_imagesizeprompt: '图片不能大于',
  AIwriter_synfailprompt: '实时同步失败',
  AIwriter_details: '详情',
  AIwriter_datadetails: '数据详情',
  AIwriter_professional: '专业的',
  AIwriter_casual: '非正式的',
  AIwriter_deletionsuccessful: '删除成功',
  AIwriter_abbreviation: '缩写',
  AIwriter_expandanarticle: '扩写',
  AIwriter_writingrefrainprompt: 'AI正在写作，请不要操作！',
  AIwriter_editor_text: '正文',
  AIwriter_editor_image_imageurl: '图片地址',
  AIwriter_editor_image_visit: '访问',
  AIwriter_editor_stock_symbol: '股票特征',
  AIwriter_editor_image_urlcheckmsg: '请输入正确的图片地址',
  AIwriter_editor_image_linkcheckmsg: '请输入正确的链接地址',
  AIwriter_editor_stock_checksourcemsg: '请输入源名称',
  AIwriter_editor_stock_stockmsg: '请填写股票代码',
  AIwriter_editor_copy_successmsg: '复制成功！',
  AIwriter_editor_copy_failmsg: '复制失败！请再试一次。',
  AIwriter_editor_words: '字数',
  AIwriter_editor_discardmsg: '需要取消AI写作么？',
  AIwriter_expandarticle: 'AI正在扩写文章',
  AIwriter_abbreviatearticle: 'AI正在缩写文章',
  AIwriter_askprompt_msg: '问你想问。。。',
  AIwriter_answerfail_msg: '对不起，回答失败，请重新尝试',
  AIwriter_stopgenerator_msg: '已停止生成',
  AIwriter_aiwriter_new: '+ 新建',
  AIwriter_aiwriter_aiwriting: 'AI 写作',
  AIwriter_aiwriter_wordsmith: 'WordSmith',
  AIwriter_aiwriter_aisearch: 'AI检索',
  AIwriter_aiwriter_aime: 'AIme',
  AIwriter_aiwriter_refine: '全文优化',
  AIwriter_aiwriter_prompt: '提示知识库',
  AIwriter_aiwriter_know: '知识库',
  AIwriter_aiwriter_brain: '头脑风暴',
  AIwriter_aiwriter_finishing: '完成文章',
  AIwriter_aiwriter_restart: '重新开始',
  AIwriter_aiwriter_next: '下一步',
  AIwriter_aiwriter_tell: '告诉AI你想写什么',
  AIwriter_aiwriter_aicreation: 'AI 创作',
  AIwriter_aiwriter_snewswire: '# 正在通过【新闻库】收集资料',
  AIwriter_aiwriter_saime: '# 正在通过【Aime】收集资料',
  AIwriter_aiwriter_sfinancials: '# 正在通过【财报库】收集资料',
  AIwriter_aiwriter_sinternet: '# 正在通过【互联网】收集资料',
  AIwriter_aiwriter_creatingk: '创建知识库',
  AIwriter_aiwriter_fromdata: '从数据库获取',
  AIwriter_aiwriter_yourdata: '你的数据',
  AIwriter_aiwriter_knowb: '知识库完成。编辑或添加更多内容。',
  AIwriter_aiwriter_youcan: '你可以在这里添加数据',
  AIwriter_aiwriter_completed: '生成写作大纲和写作思路，生成后你可以进行修改',
  AIwriter_aiwriter_aiis: 'AI 正在头脑风暴',
  AIwriter_aiwriter_completdedit: '完成。编辑或添加更多内容。',
  AIwriter_aiwriter_addanew: '+添加新节',
  AIwriter_aiwriter_writingc: '写作思路',
  AIwriter_aiwriter_confirm: '确认',
  AIwriter_aiwriter_cancel: '取消',
  AIwriter_aiwriter_click: '点击打开菜单',
  AIwriter_aiwriter_edit: '编辑',
  AIwriter_aiwriter_insert: '下方插入',
  AIwriter_aiwriter_reorder: '重新排序',
  AIwriter_aiwriter_delet: '删除',
  AIwriter_aiwriter_drag: '拖动来重新排序',
  AIwriter_aiwriter_aiisint: 'AI 正在整合文章',
  AIwriter_aiwriter_stop: '停止',
  AIwriter_aiwriter_articlefinished: '文章完成。',
  AIwriter_aiwriter_replace: '替换左侧原文',
  AIwriter_aiwriter_aiimage: 'AI生成图片',
  AIwriter_aiwriter_method1: '方式一：在下方输入框中输入提示词直接生成',
  AIwriter_aiwriter_method2: '方式二：选中文章内容，点击AI Writing 〉 Create image',
  AIwriter_aiwriter_describe: '描述想要生成的图片',
  AIwriter_aiwriter_clearall: '全部清除',
  AIwriter_aiwriter_aitools: 'AI工具',
  AIwriter_aiwriter_createimage: '生成图片',
  AIwriter_aiwriter_dragtoleft: '拖拽至左侧',
  AIwriter_aiwriter_copy: '复制',
  AIwriter_aiwriter_warning: '警告',
  AIwriter_aiwriter_switch: '切换到另一篇文章将会删除AI写作下的所有头脑风暴内容',
  AIwriter_aiwriter_areyousure: '确定要删除此标题及其所有数据吗？',
  AIwriter_aiwriter_askanything: '在下方问任何问题......',
  AIwriter_aiwriter_answer: '回答',
  AIwriter_aiwriter_chart: '图表',
  AIwriter_aiwriter_source: '来源',
  AIwriter_aiwriter_viewall: '查看全部',
  AIwriter_aiwriter_regenerate: '重新生成',
  AIwriter_aiwriter_bodycontent: '正文',
  AIwriter_generatingout: '生成写作大纲和写作思路，生成后你可以进行修改',
  AIwriter_processing2: '加载中',
  AIwriter_enterthetext: '添加文本',
  AIwriter_pressspace: '按空格打开AI写作/输入标题',
  AIwriter_noaccess: '暂无访问权限',
  AIwriter_publishTime: '选择发布时间',
  AIwriter_Attitude: '倾向',
  AIwriter_Bearish: '偏熊',
  AIwriter_Bullish: '偏牛',
  AIwriter_Neutral: '中性',
  AIwriter_Articled: '文章不存在',
  AIwriter_expens: '扩张',
  AIwriter_AITools: 'AI工具',
  AIwriter_freeacc: '免费的账户限制使用10次AI工具',
  AIwriter_gotit: '明白了。',
  AIwriter_freeacclit: '达到免费账户额度。',
  AIwriter_freeacccan: '免费账号最多可使用10次试用图像、AI写作、AIME、或其他AI工具。更多用途请升级。',
  AIwriter_aimeq: 'AIME查询注解',
  AIwriter_eval: '评价答题质量',
  AIwriter_impo: '改进AI Writer中的答案',
  AIwriter_Modifyss: '修改',
  AIwriter_annuse: '由另一用户注释',
  AIwriter_psqpm: '修改前请选择质量',
  AIwriter_allcomp: '全部完成！',
  AIwriter_yaoamto: '您正在进行注释模式，以提高AIME的回答质量。点击右侧完成标注。你仍然可以像往常一样把答案作为一篇文章发布。',
  AIwriter_submt: '提交',
  AIwriter_tyaime: '感谢您对AIME提升的帮助！',
  AIwriter_pendiing: '待定',
  AIwriter_Annotauery: '标注数据',
  AIwriter_all: '全部',
  AIwriter_Pending: '待标注',
  AIwriter_AnnotaIME: 'AIME的注解',
  AIwriter_Done: '完成',
  AIwriter_date: '日期',
  AIwriter_excellent: '好',
  AIwriter_ok: '一般',
  AIwriter_unacceptable: '差',
  AIwriter_Submitted: '已提交',
  AIwriter_SubmissionFa: '提交失败',
  AIwriter_author: '发布者',
  AIwriter_pending_cover: '待设置封面',
  AIwriter_local_upload: '本地上传',
  AIwriter_Image_generation_failed: '图像生成失败',
  AIwriter_Reload: '重新加载',
  AIwriter_Pending_Generation: '等待上传',
  AIwriter_Upload: '本地上传',
  AIwriter_AI_Image: 'AI生成',
  AIwriter_Preview: '当前封面',
  AIwriter_No_Image: '暂未选择',
  AIwriter_Regenerate: '换一批',
  AIwriter_no_content: '暂无文章内容……',
  'AIwriter_Only FYI': '仅供参考',
  AIwriter_Edit_Prompt: '编辑prompt',
  AIwriter_image_generating: '正在生成图片，请稍后',
  AIwriter_Insert: '插入',
  AIwriter_image_is_generating: '图片正在生成',
  AIwriter_Image_Generation_Fail: '图片生成失败',
  AIwriter_Chart_is_Generating: '图表正在生成',
  AIwriter_Chart_Generating_Fail: '图表生成失败',
  AIwriter_AI_Character: 'AI作者',
  AIwriter_ai_match_description: '通过我们强大的AI找到最好的作者来写你的文章',
  AIwriter_ai_manual_pick: '手动选择',
  AIwriter_ai_recommendation_button: 'AI推荐',
  AIwriter_ai_warning_insert_prompt: '请先插入您的提示词',
  AIwriter_ai_finding_match_author: '正在查找匹配作者',
  AIwriter_ai_pick_button: 'AI Pick',
  AIwriter_ai_manual_change_character: '选择',
  AIwriter_ai_redo_button: 'AI重新推荐',
  AIwriter_back_button: '返回',
  AIwriter_use_button: '使用',
  AIwriter_ai_no_result: '查询不到合适的作者',
  AIwriter_filter_reset: '重置',
  AIwriter_reset_all: '重置所有',
  AIwriter_insert_table: '插入表格',
  AIwriter_delete_table: '删除表格',
  AIwriter_merge_cell: '合并单元格',
  AIwriter_split_cell: '拆分单元格',
  AIwriter_insert_row_up: '往上插入行',
  AIwriter_insert_row_down: '往下插入行',
  AIwriter_delete_row: '删除行',
  AIwriter_insert_column_left: '往左插入列',
  AIwriter_insert_column_right: '往右插入列',
  AIwriter_delete_column: '删除列',
  AIwriter_video: '视频',
  AIwriter_video_link: '视频链接',
  AIwriter_cover: '封面',
  AIwriter_cover_image: '封面图',
  AIwriter_cover_link: '封面链接',
  dashboard_tab_writer: '创作',
  dashboard_tab_review: '审核',
  // Dashboard Writer page
  dashboard_writer_title: '审核列表',
  dashboard_writer_create_list: '创作列表',
  dashboard_writer_col_recent: '最近',
  dashboard_writer_col_createdTime: '创建时间',
  dashboard_writer_col_lastEdit: '最后编辑',
  dashboard_writer_col_status: '状态',
  dashboard_writer_status_claimable: '可领取',
  dashboard_writer_status_claimed: '已领取',
  dashboard_writer_status_editing: '编辑中',
  dashboard_writer_status_reviewed: '已审核',
  // Dashboard Review page
  dashboard_review_title: '审核列表',
  dashboard_review_col_recent: '最近',
  dashboard_review_col_writtenBy: '发布作者',
  dashboard_review_col_reviewedBy: '审核作者',
  dashboard_review_col_createdTime: '创建时间',
  dashboard_review_col_lastEdit: '最后编辑',
  dashboard_review_col_status: '状态',
  dashboard_review_status_claimable: '可领取',
  dashboard_review_status_claimed: '已领取',
  dashboard_review_status_editing: '编辑中',
  dashboard_review_success_reviewed: '文章已审核并发布',
  dashboard_review_success_published: '文章已发布',
  dashboard_review_success_dropp: '文章已驳回',
  dashboard_review_success_abandon: '文章已废弃',
  dashboard_review_search_placeholder: '文章搜索',
  dashboard_writer_search_placeholder: '标题搜索',
  dashboard_review: '精编',
  dashboard_create: '创作',
  dashboard_podcast: '播客',
  review_reviewed: '背书发布',
  review_published: '普通发布',
  review_drop: '放弃认领',
  review_abandon: '文章下线',
  review_reclaim: '重新认领',
  review_reclaim_success: '重新认领成功',
  review_confirm_ok: '确认发布',
  review_confirm_cancel: '我再改改',
  review_confirm_message: '检测到中文内容，请修改高亮部分或确认继续',
  review_action_loading: '文章仍在加载中，请稍后再试',
  dashboard_review_btn_list: '审核列表',
  dashboard_review_btn_in_review: '审核中',
  dashboard_review_btn_history: '审核历史',
  dashboard_review_stats_to_be_reviewed: '待审核',
  dashboard_review_stats_reviewed_by_me: '我审核的',
  dashboard_review_stats_total_reviewed: '总审核数',
  status_pending_review: '待审核',
  status_in_review: '审核中',
  status_reviewed: '已背书',
  status_published: '已批准',
  status_abandoned: '已拒绝',
  AIwriter_claimfailed: '该文章已被其他人认领。',
  AIwriter_cancleScheduled: '取消定时发布',
  AIwriter_cancleScheduledSuccess: '取消定时发布成功',
  AIwriter_cancleScheduledFailed: '取消定时发布失败',
  AIwriter_cancleScheduledconfirm: '你确定要取消定时发布吗？',
  dashboard_review_col_scheduledTime: '发布时间',
  AIwriter_aiwriter_createImage: '创建AI图片',
  plugin_ai_annotation: 'AI 标注',
  ai_review_title: 'AI 审核',
  ai_review_subtitle: '机器审核意见',
  ai_review_group: '审核组 {number}',
  ai_review_empty: '暂无 AI 审核数据',
  agent_review_title: '智能体审核',
  agent_review_subtitle: 'DeepSeek 智能体审核',
  agent_review_empty: '当前文章暂无智能体审核数据',
  agent_review_summary: '摘要',
  agent_review_human_review: '需要人工审核',
  agent_review_location_field: '字段：{field}',
  agent_review_location_paragraph: '第 {paragraph} 段',
  agent_review_verified_value: '核验值：{value}',
  agent_review_source: '来源：',
  agent_review_no_issues: '未发现问题',
  agent_review_expand_finding: '展开问题详情',
  agent_review_collapse_finding: '收起问题详情',
  agent_review_verified: '已核验',
  agent_review_manual_check: '人工核验',
  agent_review_feedback: '迭代建议',
  agent_review_feedback_sent_suffix: '（已发送）',
  agent_review_feedback_modal_title: '添加迭代建议',
  agent_review_send: '发送',
  agent_review_cancel: '取消',
  agent_review_feedback_placeholder: '描述发现的问题或建议...',
  agent_review_feedback_hint: '发送后将推送到 Vanish 群 {groupId}。',
  agent_review_feedback_required: '请填写迭代建议',
  agent_review_feedback_success: '迭代建议已发送到群 {groupId}',
  agent_review_feedback_error: '发送失败，请检查内网/VPN或网关配置后重试',
  agent_review_message_header: '【Agent Review 迭代建议】',
  agent_review_message_article: '文章：{title}',
  agent_review_message_url: '链接：{url}',
  agent_review_message_content: '建议内容：',
  agent_review_category_redline: '🚨 红线问题',
  agent_review_category_data: 'A. 数据准确性',
  agent_review_category_sources: 'B. 来源与引用',
  agent_review_category_ai_traces: 'C. AI 痕迹',
  agent_review_category_structure: 'D. 文章结构',
  agent_review_category_title_language: 'E. 标题与语言',
  agent_review_category_compliance: 'G. 合规性',
  agent_review_category_other: '其他',
  agent_review_sop_data_error: '数据错误',
  agent_review_sop_internal_conflict: '内部数据冲突',
  agent_review_sop_incorrect_comparison: '比较错误',
  agent_review_sop_outdated_data: '数据过期',
  agent_review_sop_entity_information: '实体信息',
  agent_review_sop_missing_citation: '缺少引用',
  agent_review_sop_citation_mismatch: '引用不匹配',
  agent_review_sop_citation_format: '引用格式',
  agent_review_sop_source_quality: '来源质量',
  agent_review_sop_ai_trace: 'AI 语义痕迹',
  agent_review_sop_template_repetition: '模板化重复',
  agent_review_sop_structure_ratio: '结构比例',
  agent_review_sop_logical_conflict: '逻辑冲突',
  agent_review_sop_repeated_content: '内容重复',
  agent_review_sop_title_issue: '标题问题',
  agent_review_sop_grammar_issue: '语法问题',
  agent_review_sop_formatting_issue: '格式问题',
  agent_review_sop_us_stock_relevance: '美股相关性',
}
